<div class="flex-grow-1 user-settings-container border-left">
  <div class="d-flex align-items-center justify-content-center flex-grow-1 ps-4" id="app-header-ic-us">
    <span class="rounded-circle d-flex align-items-center justify-content-center">
      <span class="d-inline-block fw-bold font-size-16" id="app-header-us-title-initials">
        {{ userNameInitials }}
      </span>
    </span>
    <div ngbDropdown #dropdown="ngbDropdown" [autoClose]="'outside'" placement="bottom-end" class="user-settings-dropdown d-inline-block" (openChange)="initUserSettingsDropDownOptions($event)">
      <button id="app-header-lnk-us" ngbDropdownToggle class="btn btn-link text-white d-inline-block p-0" [attr.aria-expanded]="dropdown.isOpen()" aria-haspopup="true" aria-label="Toggle user settings dropdown">
        <i class="bi bi-chevron-down"></i>
      </button>
      <ul ngbDropdownMenu aria-labelledby="app-header-lnk-us">
        <li class="dropdown-item d-flex align-items-center">
          <span class="rounded-circle d-flex align-items-center justify-content-center" id="app-header-lnk-user-name">
            <span class="d-inline-block fw-bold font-size-16 text-white" id="app-header-us-title-initials">
              {{ userNameInitials }}
            </span>
          </span>
          <h6 class="d-inline-block ps-2 mb-0 font-size-14" id="app-header-us-mdl-useremail">
            {{ userEmailName }}
          </h6>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        @if (clientList.length > 1) {
          <li class="dropdown-item">
            <div class="select-custom my-2">
              <select name="selectedClient" id="app-header-lnk-client-list" class="form-control font-size-14" [(ngModel)]="selectedClient" (change)="changeClient()">
                @for (clientDetail of clientList; track clientDetail.clientCode) {
                  <option [value]="clientDetail.clientName">{{ clientDetail.clientName }}</option>
                }
              </select>
              <i class="p-1">
                <img src="assets/images/chevron-down.svg" />
                <span class="visually-hidden-focusable font-size-12">Client List Arrow Down</span>
              </i>
            </div>
          </li>
        }
        @if (!switchClientStatusIndicator) {
          <li>
            <button
              *ngxPermissionsOnly="['app-integrations-admin', 'file-config-read', 'file-uploads-read']"
              class="dropdown-item btn-link"
              id="app-header-us-btn-admin"
              (click)="navigateToRoute()"
              type="button"
              aria-label="Navigate to Application Integrations">
              {{ headerContents.profileRedirectData.applicationIntegrations }}
            </button>
          </li>
        }
        @if (!switchClientStatusIndicator) {
          <li>
            <button *ngxPermissionsOnly="['self-service-token-generation']" class="dropdown-item btn-link" id="app-header-us-btn-api-tokens" (click)="navigateToApiTokens()" type="button" aria-label="Navigate to My API Access Token">
              {{ headerContents.profileRedirectData.myApiAccessToken }}
            </button>
          </li>
        }
        @if (switchClientStatusIndicator) {
          <li class="d-flex justify-content-center align-items-center">
            <div class="spinner-border spinner-border-sm small m-3" role="status" id="app-header-us-spinner">
              <span class="visually-hidden">Loading...</span>
            </div>
          </li>
        }
        @if (!switchClientStatusIndicator) {
          <li>
            <a *ngxPermissionsOnly="['user-settings-market-automation']" class="dropdown-item link-primary" href="{{ marketingAutomationUrl }}" target="_blank" id="app-header-us-lnk-ma" [ngClass]="{ disabled: marketingAutomationUrl === '' }">
              Marketing Automation
            </a>
          </li>
          @if (legacyHelpDesk) {
            <li>
              <a id="app-header-us-lnk-kc" class="dropdown-item link-primary" href="{{ userSettingsEndpoints.helpCenterUrl }}" target="_blank">{{ headerContents.profileRedirectData.helpCenter }}-Legacy</a>
            </li>
          }
          @if (!dXeHelpEnabled && !legacyHelpDesk) {
            <li>
              <a id="app-header-us-lnk-kc" class="dropdown-item link-primary" href="{{ userSettingsEndpoints.helpCenterUrl }}" target="_blank">
                {{ headerContents.profileRedirectData.helpCenter }}
              </a>
            </li>
          }
          <li>
            @if (isConsoleLogin) {
              <a id="app-header-us-lnk-mc" class="dropdown-item link-primary" href="{{ userSettingsEndpoints.mercuryConsoleUrl }}" target="_blank">
                {{ headerContents.profileRedirectData.mercuryConsole }}
              </a>
            }
          </li>
          <!-- API Documentation is hidden from users for now; the /docs route itself stays reachable by direct URL.
          <li>
            <a id="app-header-us-lnk-api-docs" class="dropdown-item link-primary" [href]="apiDocumentationRoute" target="_blank" rel="noopener">
              {{ headerContents.profileRedirectData.apiDocumentation }}
            </a>
          </li>
          -->
          <li>
            <button *ngxPermissionsOnly="['user-settings-usage-report']" id="app-header-us-lnk-usage-report" (click)="downloadUsageReport()" [ngClass]="{ disabled: usageReportDownloadUrl === '' }" class="dropdown-item btn-link" type="button">
              Download Usage Report
              @if (usageReportDownloadUrl && reportCreatedDate) {
                <span>({{ reportCreatedDate }})</span>
              }
            </button>
          </li>
          <li>
            <button class="dropdown-item btn-link" type="button" (click)="navigateToFeedbackPortal()">
              {{ headerContents.profileRedirectData.productFeedbackPortal }}
            </button>
          </li>
          @if (dXeHelpEnabled || legacyHelpDesk) {
            <li>
              <button class="dropdown-item btn-link" type="button" target="_blank" (click)="navigateToHelpCenter()">
                {{ headerContents.profileRedirectData.helpCenter }}
              </button>
            </li>
          }
        }
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li class="text-center">
          <a class="dropdown-item link-primary cursor-pointer fw-bold" id="app-header-us-btn-logout" (click)="logout()">
            {{ headerContents.profileRedirectData.logout }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
